import React from "react";
import { Button } from "@mui/material";
import BoltOutlined from "@mui/icons-material/BoltOutlined";
import Flx from "../layout/Flx";
import Txt from "../typography/Txt";
import colors from "../../theme/colors";
import { IS_LOCAL_DEV } from "./devPrefill";

/**
 * Local-only strip beneath the form card offering a one-click fill of every
 * required field, so the later steps can be reached without retyping the whole
 * application.
 *
 * Renders nothing unless IS_LOCAL_DEV. Deliberately styled as a dashed scaffold
 * rather than in the form's own visual language — it should never read as part
 * of the borrower-facing surface, and if it ever does show up somewhere it
 * shouldn't, it should look obviously wrong.
 *
 * Sits OUTSIDE the form card (see PublicFormShell's `devTools` slot) so it can't
 * be mistaken for a step action, and so it doesn't disturb the card's own
 * footer/divider rhythm.
 */
const DevPrefillBar = ({
  onPrefill,
  label = "Prefill with test data",
  note = "Local only — fills every required field so you can click straight through.",
}) => {
  if (!IS_LOCAL_DEV) return null;

  return (
    <Flx
      between
      centerY
      gap={2}
      sx={{
        border: `1px dashed ${colors.slate300}`,
        borderRadius: "10px",
        px: 2,
        py: 1.5,
        background: "transparent",
      }}
    >
      <Flx column gap={0.25} sx={{ minWidth: 0 }}>
        <Txt
          component="div"
          sx={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: colors.slate500,
          }}
        >
          Developer
        </Txt>
        <Txt
          component="div"
          sx={{ fontSize: 12.5, color: colors.slate500 }}
        >
          {note}
        </Txt>
      </Flx>
      {/* variant="outlined" so the theme owns the text color — never set a
          button's color without also setting its background. */}
      <Button
        type="button"
        variant="outlined"
        size="small"
        startIcon={<BoltOutlined />}
        onClick={onPrefill}
        sx={{ flexShrink: 0 }}
      >
        {label}
      </Button>
    </Flx>
  );
};

export default DevPrefillBar;
